/**
 * Parse a generic wrapper pattern.
 * Example:  "{1} at {0}"
 */
export var parseWrapperPattern = function (raw) {
    var nodes = [];
    var len = raw.length;
    var buf = '';
    var inquote = false;
    var intag = false;
    var i = 0;
    while (i < len) {
        var ch = raw[i];
        switch (ch) {
            case '{':
                if (buf.length > 0) {
                    nodes.push(buf);
                    buf = '';
                }
                intag = true;
                break;
            case '}':
                intag = false;
                break;
            case "'":
                if (inquote) {
                    inquote = false;
                }
                else {
                    inquote = true;
                }
                break;
            default:
                if (intag) {
                    // Index doesn't exceed single digits.
                    nodes.push(Number(ch));
                }
                else {
                    buf += ch;
                }
                break;
        }
        i++;
    }
    if (buf.length > 0) {
        nodes.push(buf);
    }
    return nodes;
};
//# sourceMappingURL=wrapper.js.map